import type { IconComponent } from 'uikit';
import { Badge, cnMixSpace, Text } from 'uikit';

import type React from 'react';
import { useMemo } from 'react';

import { ComponentWithTooltip } from '../ComponentWithTooltip';

interface IBadgeWithTooltip {
    label?: string | undefined;
    size?: 's' | 'm' | 'l';
    badgeSize?: 's' | 'm' | 'l';
    status?: 'normal' | 'success' | 'warning' | 'error' | 'system';
    iconLeft?: IconComponent;
    messages?: string[];
    message?: string;
    className?: string;
}

export const BadgeWithTooltip: React.FC<IBadgeWithTooltip> = (props) => {
    const { label, size, iconLeft, status, messages, message, badgeSize, className } = props;

    const tooltipText = useMemo(
        () => (
            <>
                {(messages?.length ? messages : [message || '']).map((error: string, idx: number) => (
                    <Text as="div" key={idx} lineHeight={size} className={cnMixSpace({ mB: 'xs' })}>
                        {error}
                    </Text>
                ))}
            </>
        ),
        [message, messages, size],
    );

    return (
        <ComponentWithTooltip tooltipText={tooltipText} size={size} className={className}>
            <Badge size={badgeSize} label={label} status={status} iconLeft={iconLeft} />
        </ComponentWithTooltip>
    );
};

BadgeWithTooltip.displayName = 'BadgeWithTooltip';
